export const COUNTRY_LIST = [
 //{key: "93", id: "Afghanistan"},
 {key: "355", id: "Albania"},
 {key: "213", id: "Algeria"},
 {key: "376", id: "Andorra"},
 {key: "244", id: "Angola"},
 {key: "1", id: "Antigua and Barbuda"},
 {key: "54", id: "Argentina"},
 {key: "374", id: "Armenia"},
 {key: "61", id: "Australia"},
 {key: "43", id: "Austria"},
 {key: "994", id: "Azerbaijan"},
 {key: "1", id: "Bahamas"},
 {key: "973", id: "Bahrain"},
 {key: "880", id: "Bangladesh"},
 {key: "1", id: "Barbados"},
// {key: "375", id: "Belarus"},
 {key: "32", id: "Belgium"},
 {key: "501", id: "Belize"},
 {key: "229", id: "Benin"},
 {key: "975", id: "Bhutan"},
 {key: "591", id: "Bolivia"},
// {key: "387", id: "Bosnia and Herzegovina"},
 {key: "267", id: "Botswana"},
 {key: "55", id: "Brazil"},
 {key: "673", id: "Brunei"},
 {key: "359", id: "Bulgaria"},
 {key: "226", id: "Burkina Faso"},
// {key: "257", id: "Burundi"},
 {key: "225", id: "Côte d'Ivoire"},
 {key: "238", id: "Cape Verde"},
 {key: "855", id: "Cambodia"},
 {key: "237", id: "Cameroon"},
 {key: "1", id: "Canada"},
// {key: "236", id: "Central African Republic"},
 {key: "235", id: "Chad"},
 {key: "56", id: "Chile"},
 {key: "86", id: "China"},
 {key: "57", id: "Colombia"},
 {key: "269", id: "Comoros"},
 {key: "242", id: "Congo (Congo-Brazzaville)"},
 {key: "506", id: "Costa Rica"},
 {key: "385", id: "Croatia"},
 {key: "53", id: "Cuba"},
 {key: "357", id: "Cyprus"},
 {key: "420", id: "Czechia (Czech Republic)"},
// {key: "243", id: "Democratic Republic of the Congo"},
 {key: "45", id: "Denmark"},
 {key: "253", id: "Djibouti"},
 {key: "1", id: "Dominica"},
 {key: "1", id: "Dominican Republic"},
 {key: "593", id: "Ecuador"},
 {key: "20", id: "Egypt"},
 {key: "503", id: "El Salvador"},
 {key: "240", id: "Equatorial Guinea"},
 {key: "291", id: "Eritrea"},
 {key: "372", id: "Estonia"},
 {key: "268", id: "Eswatini"},
 {key: "251", id: "Ethiopia"},
 {key: "679", id: "Fiji"},
 {key: "358", id: "Finland"},
 {key: "33", id: "France"},
 {key: "241", id: "Gabon"},
 {key: "220", id: "Gambia"},
 {key: "995", id: "Georgia"},
{key: "49", id: "Germany"},
{key: "233", id: "Ghana"},
{key: "30", id: "Greece"},
{key: "1", id: "Grenada"},
{key: "502", id: "Guatemala"},
//{key: "224", id: "Guinea"},
//{key: "245", id: "Guinea-Bissau"},
{key: "592", id: "Guyana"},
//{key: "509", id: "Haiti"},
{key: "504", id: "Honduras"},
{key: "36", id: "Hungary"},
{key: "354", id: "Iceland"},
{key: "91", id: "India"},
{key: "62", id: "Indonesia"},
//{key: "98", id: "Iran"},
//{key: "964", id: "Iraq"},
{key: "353", id: "Ireland"},
{key: "972", id: "Israel"},
{key: "39", id: "Italy"},
{key: "1", id: "Jamaica"},
{key: "81", id: "Japan"},
{key: "962", id: "Jordan"},
{key: "7", id: "Kazakhstan"},
{key: "254", id: "Kenya"},
{key: "686", id: "Kiribati"},
{key: "965", id: "Kuwait"},
{key: "996", id: "Kyrgyzstan"},
{key: "856", id: "Laos"},
{key: "371", id: "Latvia"},
//{key: "961", id: "Lebanon"},
{key: "266", id: "Lesotho"},
{key: "231", id: "Liberia"},
//{key: "218", id: "Libya"},
{key: "423", id: "Liechtenstein"},
{key: "370", id: "Lithuania"},
{key: "352", id: "Luxembourg"},
{key: "261", id: "Madagascar"},
{key: "265", id: "Malawi"},
{key: "60", id: "Malaysia"},
{key: "960", id: "Maldives"},
//{key: "223", id: "Mali"},
{key: "356", id: "Malta"},
{key: "692", id: "Marshall Islands"},
{key: "222", id: "Mauritania"},
{key: "230", id: "Mauritius"},
{key: "52", id: "Mexico"},
{key: "691", id: "Micronesia"},
{key: "373", id: "Moldova"},
{key: "377", id: "Monaco"},
{key: "976", id: "Mongolia"},
{key: "382", id: "Montenegro"},
{key: "212", id: "Morocco"},
{key: "258", id: "Mozambique"},
//{key: "95", id: "Myanmar (formerly Burma)"},
{key: "264", id: "Namibia"},
{key: "674", id: "Nauru"},
{key: "977", id: "Nepal"},
{key: "31", id: "Netherlands"},
{key: "64", id: "New Zealand"},
//{key: "505", id: "Nicaragua"},
{key: "227", id: "Niger"},
{key: "234", id: "Nigeria"},
//{key: "850", id: "North Korea"},
{key: "389", id: "North Macedonia"},
{key: "47", id: "Norway"},
{key: "968", id: "Oman"},
{key: "92", id: "Pakistan"},
{key: "680", id: "Palau"},
{key: "970", id: "Palestine State"},
{key: "507", id: "Panama"},
{key: "675", id: "Papua New Guinea"},
{key: "595", id: "Paraguay"},
{key: "51", id: "Peru"},
{key: "63", id: "Philippines"},
{key: "48", id: "Poland"},
{key: "351", id: "Portugal"},
{key: "974", id: "Qatar"},
{key: "40", id: "Romania"},
//{key: "7", id: "Russia"},
{key: "250", id: "Rwanda"},
{key: "1", id: "Saint Kitts and Nevis"},
{key: "1", id: "Saint Lucia"},
{key: "1", id: "Saint Vincent and the Grenadines"},
{key: "685", id: "Samoa"},
{key: "378", id: "San Marino"},
{key: "239", id: "Sao Tome and Princip"},
{key: "966", id: "Saudi Arabia"},
{key: "221", id: "Senegal"},
{key: "381", id: "Serbia"},
{key: "248", id: "Seychelles"},
{key: "232", id: "Sierra Leone"},
{key: "65", id: "Singapore"},
{key: "421", id: "Slovakia"},
{key: "386", id: "Slovenia"},
{key: "677", id: "Solomon Islands"},
//{key: "252", id: "Somalia"},
{key: "27", id: "South Africa"},
{key: "82", id: "South Korea"},
//{key: "211", id: "South Sudan"},
{key: "34", id: "Spain"},
{key: "94", id: "Sri Lanka"},
//{key: "249", id: "Sudan"},
{key: "597", id: "Suriname"},
{key: "46", id: "Sweden"},
{key: "41", id: "Switzerland"},
//{key: "963", id: "Syria"},
{key: "992", id: "Tajikistan"},
{key: "255", id: "Tanzania"},
{key: "66", id: "Thailand"},
{key: "670", id: "Timor-Leste"},
{key: "228", id: "Togo"},
{key: "676", id: "Tonga"},
{key: "1", id: "Trinidad and Tobago"},
{key: "216", id: "Tunisia"},
{key: "90", id: "Turkey"},
{key: "993", id: "Turkmenistan"},
{key: "688", id: "Tuvalu"},
{key: "256", id: "Uganda"},
{key: "380", id: "Ukraine"},
{key: "971", id: "United Arab Emirates"},
{key: "44", id: "United Kingdom"},
{key: "1", id: "United States of America"},
{key: "598", id: "Uruguay"},
{key: "998", id: "Uzbekistan"},
{key: "678", id: "Vanuatu"},
//{key: "58", id: "Venezuela"},
{key: "84", id: "Vietnam"},
//{key: "967", id: "Yemen"},
{key: "260", id: "Zambia"},
//{key: "263", id: "Zimbabwe"},
];
